import { useState, useEffect, useRef } from 'react';

export const useLoadingStep = (isLoading: boolean) => {
  const [statusStep, setStatusStep] = useState(3); // 3: 기본, 0:로딩, 1:오래걸림, 2:완료
  const loadingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const completionTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isLoading) {
      setStatusStep(0);
      loadingTimeoutRef.current = setTimeout(() => {
        setStatusStep(1);
      }, 10000);
    } else if (statusStep !== 3) {
      setStatusStep(2);
      completionTimeoutRef.current = setTimeout(() => {
        setStatusStep(3);
      }, 2000);
    }
    return () => {
      if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current);
      if (completionTimeoutRef.current) clearTimeout(completionTimeoutRef.current);
    };
  }, [isLoading, statusStep]);

  return statusStep;
};
